"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'knowledge.bulkUpload.files.successProcessing': 'I tuoi {count} file saranno elaborati in background e aggiunti alla tua base di conoscenza.',
    'knowledge.bulkUpload.files.partialSuccess': '{successCount} file saranno elaborati in background, {errorCount} sono falliti.',
    'knowledge.bulkUpload.files.allFailed': 'Errore nel caricamento di tutti i {count} file.',
    'knowledge.bulkUpload.googleDrive.successProcessing': 'La directory di Google Drive "{directoryName}" sarà elaborata in background e aggiunta alla tua base di conoscenza.',
};
